/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendIdDto } from '../../models/backend-id-dto';
import { BackendIdRequestDto } from '../../models/backend-id-request-dto';

export interface ProjectTaxesUnblockTaxesVariantsCreate$Params {
  body: BackendIdRequestDto;
}

export function projectTaxesUnblockTaxesVariantsCreate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesUnblockTaxesVariantsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendIdDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesUnblockTaxesVariantsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendIdDto>;
    }),
  );
}

projectTaxesUnblockTaxesVariantsCreate.PATH = '/api/project_taxes/unblock-taxes-variants/';
